import { Icon } from '../../components/ui/Icon';
import type { Suite } from '../../data/types/platform';

export interface SuiteSectionProps {
  suite: Suite;
  index: number;
  goToSystem: (systemId: string, moduleId?: string) => void;
}

export function SuiteSection({ suite, index, goToSystem }: SuiteSectionProps) {
  const num = String(index).padStart(2, '0');
  return (
    <section className="suite-sec">
      <div className="ss-head">
        <span className="ss-num">{num}</span>
        <h2 className="ss-title">{suite.he}</h2>
        <span className="ss-en">{suite.en}</span>
        <span className="ss-abstract">{suite.abstract}</span>
        <button className="ss-open" onClick={() => goToSystem(suite.id)} type="button">
          פתח את המערכת <Icon name="arrow-left" size={12} />
        </button>
      </div>
      <div className="module-grid">
        {suite.modules.slice(0, 6).map((m) => (
          <div className="module-card" key={m.id} onClick={() => goToSystem(suite.id, m.id)}>
            <div className="mc-top">
              <div className="mc-name">{m.he}</div>
              {m.phase && <span className="mc-phase">{m.phase}</span>}
            </div>
            <div className="mc-sub">{m.sub}</div>
            <div className="mc-meta">
              <span className={'health ' + (m.health === 'live' ? '' : m.health)} />
              <span>{m.owner}</span>
              <span>·</span>
              <span>{m.updated}</span>
              {m.pinned && <span className="h-pinned"><Icon name="pin" size={10} /></span>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
